export enum ProductionStatus {
    IN_PRODUCTION = "in_production",
    CANCELED = "canceled",
    PARTIALLY_COMPLETED = "invoiced",
    COMPLETED = "completed",
    OPEN = "open",
}
